module.exports = __webpack_public_path__ + "202408221624/img/1.81ecf3ed.jpg";